/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';
import { leaderboardStore } from '../store/leaderboard.store.js';
// Public anon key only — no write access without server JWT
const supabase = createClient(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_ANON_KEY);
let channel = null;
export function subscribeToLeaderboard(seasonId) {
    if (channel) {
        supabase.removeChannel(channel);
    }
    channel = supabase
        .channel(`leaderboard:${seasonId}`)
        .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'members',
        filter: `season_id=eq.${seasonId}`,
    }, (payload) => {
        leaderboardStore.addMember(payload.new);
    })
        .on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'members',
        filter: `season_id=eq.${seasonId}`,
    }, (payload) => {
        leaderboardStore.updateMember(payload.new);
    })
        .on('postgres_changes', {
        event: 'DELETE',
        schema: 'public',
        table: 'members',
        filter: `season_id=eq.${seasonId}`,
    }, (payload) => {
        leaderboardStore.removeMember(payload.old.id);
    })
        .subscribe();
    return () => {
        if (channel)
            supabase.removeChannel(channel);
    };
}
